import axios from "axios";

export function callUserManagementUpdate(payload: Record<string, unknown>) {
    return axios("api/Users/update-user-account-user-management", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify(payload)
    });
}

export function callAccountManagementUpdate(payload: Record<string, unknown>) {
    return axios("api/Users/update-user-account", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify(payload)
    });
}
